module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a6-12-d0dff01d66d180756b642dcdc6357f2d.jpg";